<!-- <header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">IGM Desk</div>
      <div class="page_desc">View vessel and container information</div>
    </div>
    <div class="action_btn">
      <button class="add_new_btn" (click)="uploadFile()">
        <img src="assets/icons/plus_icon.svg" height="20" width="20">Upload File
      </button>
    </div>
  </div>
</header> -->
<div class="container">
  <div class="search_bar_action_btns">
    
    <div class="search_bar">
        <div class="search_container">
          <input
            type="text"
            name="search_table"
            id="search_table"
            [(ngModel)]="searchTerm"
            placeholder="Search by Container Number"
            (focus)="focusSearch = true"
            (focusout)="focusSearch = false"
            (keyup)="handleTableSearch($event)"
          >
          <img src="assets/icons/search_icon.svg" class="search_icon">
        </div>
  
        <div class="filter_btn">
          <!-- <button (click)="filter()">
            <img src="assets/icons/filter.svg">
            Filters
          </button> -->
        </div>
    </div>

    <div class="action_section">
      <button class="add_new_btn" (click)="uploadFile()">
        <img src="assets/icons/plus_icon.svg" height="20" width="20">Upload File
      </button>
    </div>
  </div>

  <app-tos-table
        [showTableStats]="false"
        [tableMeta]="tableMeta"
        [tableMenuOptions]="menuOptions"
        [(dataListRequest)]="tableListRequest"
        [dataListResponse]="tableListData"
        [(allTableRecordsSelected)]="allTableRecordsSelected"
        [(selectedItems)]="selectedItems"
        (tosTableAction)="fetchAllRecords()"
        (tableMenuOptionSelected)="handleMenuOptionSelection($event)"
></app-tos-table>
</div>
